/* @flow */

import React from 'react';
import { Message } from 'semantic-ui-react';

type Props = {
  visible: boolean,
};

const PageArchivedWarning = ({ visible }: Props) => {
  if (visible) {
    return (
      <Message
        error
        icon="warning circle"
        header="Cette page est désactivée"
        content={`Vous pouvez la réactiver via l'onglet "Mes Archives"`}
      />
    );
  }

  return null;
};

export default PageArchivedWarning;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Page/Edit/components/PageArchivedWarning.js